var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import Divider from "../../../../shared/components/divider";
import Template from "../../../../shared/components/template";
import * as styles from "./styles.css";
var TemplateDetail = function (_a) {
    var children = _a.children;
    var _b;
    var areas = {
        activitiesLodging: null,
        activityFeatures: null,
        adRail: null,
        adSuperzone: null,
        breadcrumbs: null,
        callToActionAside: null,
        callToActionMobile: null,
        descriptionPartner: null,
        header: null,
        hero: null,
        heroAttribution: null,
        hotels: null,
        infoEssential: null,
        infoLocation: null,
        map: null,
        reviewEssential: null,
        reviewExtension: null,
        suggestEdit: null,
        tour: null,
        tourItinerary: null,
    };
    if (children) {
        var theChildren = {};
        if (Array.isArray(children)) {
            theChildren = children.reduce(function (acc, child) {
                var area = child ? child.props.area : null;
                if (area) {
                    acc[area] = child;
                }
                return acc;
            }, areas);
        }
        else {
            if (children.props.area) {
                var child = children;
                var area = child.props.area;
                theChildren = (_b = {},
                    _b[area] = child,
                    _b);
            }
        }
        areas = __assign({}, areas, theChildren);
    }
    return (React.createElement(Template, { className: styles.template, key: "poiDetail" },
        areas.breadcrumbs &&
            React.createElement(Template.Area, { key: "breadcrumbs", className: cn(styles.templateArea, styles.templateAreaBreadcrumbs) }, areas.breadcrumbs),
        areas.header &&
            React.createElement(Template.Area, { key: "header", className: cn(styles.templateArea, styles.templateAreaHeader) }, areas.header),
        React.createElement("div", { className: cn(styles.templateArea, styles.templateAreaLeftRail) },
            React.createElement("div", { className: cn(styles.templateArea, styles.templateAreaLeftRail, styles.templateAreaHeroSubGrid) },
                areas.hero &&
                    React.createElement(Template.Area, { key: "hero", className: cn(styles.templateArea, styles.templateAreaHero) }, areas.hero),
                areas.heroAttribution &&
                    React.createElement(Template.Area, { key: "heroAttribution", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaHeroAttribution) }, areas.heroAttribution)),
            areas.callToActionMobile &&
                React.createElement(Template.Area, { key: "callToActionMobile", className: cn(styles.templateArea, styles.templateAreaCallToActionMobile) }, areas.callToActionMobile),
            areas.reviewEssential &&
                React.createElement(Template.Area, { key: "reviewEssential", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.reviewEssential)),
        React.createElement("aside", { className: styles.templateAreaRightRail },
            areas.callToActionAside &&
                React.createElement(Template.Area, { key: "callToActionAside", className: cn(styles.templateArea, styles.templateAreaRightRailModule, styles.templateAreaCallToActionAside, areas.callToActionMobile && styles.templateAreaCallToActionAsideDesktopOnly) }, areas.callToActionAside),
            areas.infoLocation &&
                React.createElement(React.Fragment, null,
                    React.createElement(Template.Area, { key: "infoLocation", className: cn(styles.templateArea, styles.templateAreaRightRailModule, styles.templateAreaRightRailModulePadded) }, areas.infoLocation),
                    React.createElement(Divider, { className: styles.templateAreaRightRailDivider })),
            areas.infoEssential &&
                React.createElement(React.Fragment, null,
                    React.createElement(Template.Area, { key: "infoEssential", className: cn(styles.templateArea, styles.templateAreaRightRailModule, styles.templateAreaRightRailModulePadded) }, areas.infoEssential),
                    React.createElement(Divider, { className: styles.templateAreaRightRailDivider })),
            areas.activitiesLodging &&
                React.createElement(React.Fragment, null,
                    React.createElement(Template.Area, { key: "activitiesLodging", className: cn(styles.templateArea, styles.templateAreaRightRailModule) }, areas.activitiesLodging),
                    React.createElement(Divider, { className: styles.templateAreaRightRailDivider })),
            areas.adRail &&
                React.createElement(Template.Area, { key: "adRail", className: cn(styles.templateArea, styles.templateAreaRightRailModule, styles.templateAreaAdRail) }, areas.adRail)),
        React.createElement("div", { className: cn(styles.templateArea, styles.templateAreaLeftRail) },
            areas.map &&
                React.createElement(Template.Area, { key: "map", className: cn(styles.templateArea, styles.templateAreaHero, styles.templateAreaMap) }, areas.map),
            areas.reviewExtension &&
                React.createElement(Template.Area, { key: "reviewExtension", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.reviewExtension),
            areas.descriptionPartner &&
                React.createElement(Template.Area, { key: "descriptionPartner", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.descriptionPartner),
            areas.suggestEdit &&
                React.createElement(Template.Area, { key: "suggestEdit", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.suggestEdit),
            areas.activityFeatures &&
                React.createElement(React.Fragment, null,
                    React.createElement(Divider, { className: styles.templateAreaLeftRailModule }),
                    React.createElement(Template.Area, { key: "activityFeatures", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.activityFeatures)),
            areas.tourItinerary &&
                React.createElement(React.Fragment, null,
                    React.createElement(Divider, { className: styles.templateAreaLeftRailModule }),
                    React.createElement(Template.Area, { key: "tourItinerary", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaArticle) }, areas.tourItinerary)),
            areas.tour &&
                React.createElement(React.Fragment, null,
                    React.createElement(Divider, { className: styles.templateAreaLeftRailModule }),
                    React.createElement(Template.Area, { key: "tour", className: cn(styles.templateArea, styles.templateAreaLeftRailModule, styles.templateAreaRelatedTour) }, areas.tour))),
        areas.hotels &&
            React.createElement(React.Fragment, null,
                React.createElement(Divider, { className: styles.templateAreaLeftRailModule }),
                React.createElement(Template.Area, { key: "hotels", className: cn(styles.templateArea, styles.templateAreaRelatedHotels) }, areas.hotels)),
        React.createElement(Template.Area, { key: "adSuperzone", className: cn(styles.templateArea, styles.templateAreaAdSuperzone) }, areas.adSuperzone)));
};
export default TemplateDetail;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/templates/detail/index.tsx
// module id = tpip
// module chunks = 2